import { render } from "./EscalierMarron.vue?vue&type=template&id=3d436e9a&scoped=true"
import script from "./EscalierMarron.vue?vue&type=script&lang=js"
export * from "./EscalierMarron.vue?vue&type=script&lang=js"

import "./EscalierMarron.vue?vue&type=style&index=0&id=3d436e9a&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d436e9a"]])

export default __exports__